import { useContext, useEffect, useRef, useState } from 'react';

import { ApplicationContext } from '@App/contexts/Application';
import useConversionTracking from '@src/app/hooks/useConversionTracking';
import { useTrackStartFactFind } from '@src/app/hooks/useTrackStartFactFind';

import EligibilityLayout from '../layouts/EligibilityLayout';
import ApplicantsView from '../views/eligibility/ApplicantsView';

const Applicants = () => {
    const {
        applicants,
        loading,
        activeApplicant,
        setActiveApplicant,
        saveApplicants,
        applicationId,
        applicationEmail,
    } = useContext(ApplicationContext);

    const [localApplicant, setLocalApplicant] = useState(null);

    const saveRef = useRef(null);

    useEffect(() => {
        if (window.hj && applicationEmail) {
            window.hj('identify', applicationEmail, {
                applicationId: applicationId,
            });
        }
    }, [applicationEmail, applicationId]);

    if (window.environment.toUpperCase() === 'PRODUCTION') {
        window.kameleoonQueue?.push({
            level: 'IMMEDIATE',
            command: () =>
                window.Kameleoon?.API.Visitor.setVisitorCode(applicationEmail),
        });
    }

    useConversionTracking(applicationEmail, 369355);

    useEffect(() => {
        setLocalApplicant(activeApplicant || 0);
        setActiveApplicant(null);
    }, [activeApplicant, setActiveApplicant, setLocalApplicant]);

    useTrackStartFactFind();

    return (
        <EligibilityLayout loading={loading} ref={saveRef}>
            <ApplicantsView
                applicantsData={applicants}
                activeApplicant={localApplicant}
                saveApplicants={saveApplicants}
                ref={saveRef}
            />
        </EligibilityLayout>
    );
};

export default Applicants;
